import './_contactMe.scss';
import { GrLinkedin, GrGithub, GrTwitter, GrMail } from 'react-icons/gr';
import Icon from '../../context/Icon';

function ContactMe() {
    const linkedin = 'https://www.linkedin.com/in/guillermo-david-zevallos-escalante-4993901a7/';
    const mail = 'mailto:guiller.zeva16@gmail.com';
    const github = 'https://github.com/ZevaGuillo';
    const twitter = 'https://twitter.com/ZevaGuillo';

    const openInNewTab = (url) => {
        window.open(url, "_blank", "noopener,noreferrer");
    };

    return (
        <section className='contact-me container'>
            <h2 className='text-gradient'>Contáctame</h2>
            <div className='accounts'>
                <Icon click={() => openInNewTab(linkedin)} classname='linkedin'>
                    <GrLinkedin />
                </Icon>
                <Icon click={() => openInNewTab(mail)} classname='mail'>
                    <GrMail />
                </Icon>
                <Icon click={() => openInNewTab(github)} classname='github'> 
                    <GrGithub />
                </Icon>
                <Icon click={() => openInNewTab(twitter)} classname='twitter'>
                    <GrTwitter />
                </Icon>
            </div>
            
        </section>
    )
}

export default ContactMe